/**
 * 学习乐园 · 排排序题材包：数位顺序（paixu/pack-shuwei.js）
 * ---------------------------------------------------------------------------
 * 个十百千万十万百万千万亿从低到高排。考的不是背词，是「每满十进一位」
 * 的进位手感——note 全部写成「十个×凑成×」的同一句式，排完顺带把
 * 相邻进率 10 这件事自己读出来。亿是小学常用数位的顶，如实收口。
 */
(function (global) {
  'use strict';
  var PACKS = global.STPX_PACKS = global.STPX_PACKS || {};

  PACKS.shuwei = {
    id: 'shuwei',
    name: '数位顺序',
    hint: '从个位排到亿位',
    cols: 3,
    winText: '个十百千万十万百万千万亿——每满十就进一位，读数写数都靠这张顺序表。',
    items: [
      { face: '个', note: '最低的数位，表示几个一' },
      { face: '十', note: '十个一凑成十' },
      { face: '百', note: '十个十凑成一百' },
      { face: '千', note: '十个百凑成一千' },
      { face: '万', note: '十个千凑成一万' },
      { face: '十万', note: '十个万凑成十万' },
      { face: '百万', note: '十个十万凑成一百万' },
      { face: '千万', note: '十个百万凑成一千万' },
      { face: '亿', note: '十个千万凑成一亿，小学常用数位到这里到顶' }
    ]
  };
})(typeof window !== 'undefined' ? window : globalThis);
